module.exports = __webpack_public_path__ + "img/horizontal_5_1_0.e6c40e1d.png";